import useModuleVariables from "../../hooks/useModuleVariables";

const SidebarContent = () => {
  const {
    Dashboard,
    Repository,
    ProjectListing,
    ProjectInitiation,
    IPD,
    InitiationApproval,
    CogsEstimation,
    Commercials,
    InHouseSelection,
    FormulationBudgetForm,
    APIDevelopmentForm,
    APICommercials,
    InLicensedProject,
    FinalSchedule,
    RevenueGCRollUp,
    FinalPLEvaluataion,
    Reports,
    Admin,
    UserManagement,
    MasterManagement,
    DateFormat,
    GroupCurrency,
    GroupUom,
    FinalApproval,
    FormulationDevelopment,
    API,
    ExcipientsPM,
    Analytical,
    BERLDCost,
    ToolingPlantCost,
    ManpowerCost,
    FilingCost,
    APIDevelopment,
    APIRequirement,
    OtherMaterials,
    AnalyticalAPI,
    ManpowerAPI,
    Tooling,
    PlantCost,
    APIFilingCost,
    Documents
  } = useModuleVariables();

  const SidebarContentItem = [
    {
      label: "Dashboard",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 6C2 4.11438 2 3.17157 2.58579 2.58579C3.17157 2 4.11438 2 6 2C7.88562 2 8.82843 2 9.41421 2.58579C10 3.17157 10 4.11438 10 6V8C10 9.88562 10 10.8284 9.41421 11.4142C8.82843 12 7.88562 12 6 12C4.11438 12 3.17157 12 2.58579 11.4142C2 10.8284 2 9.88562 2 8V6Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M2 19C2 18.0681 2 17.6022 2.15224 17.2346C2.35523 16.7446 2.74458 16.3552 3.23463 16.1522C3.60218 16 4.06812 16 5 16H7C7.93188 16 8.39782 16 8.76537 16.1522C9.25542 16.3552 9.64477 16.7446 9.84776 17.2346C10 17.6022 10 18.0681 10 19C10 19.9319 10 20.3978 9.84776 20.7654C9.64477 21.2554 9.25542 21.6448 8.76537 21.8478C8.39782 22 7.93188 22 7 22H5C4.06812 22 3.60218 22 3.23463 21.8478C2.74458 21.6448 2.35523 21.2554 2.15224 20.7654C2 20.3978 2 19.9319 2 19Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M14 16C14 14.1144 14 13.1716 14.5858 12.5858C15.1716 12 16.1144 12 18 12C19.8856 12 20.8284 12 21.4142 12.5858C22 13.1716 22 14.1144 22 16V18C22 19.8856 22 20.8284 21.4142 21.4142C20.8284 22 19.8856 22 18 22C16.1144 22 15.1716 22 14.5858 21.4142C14 20.8284 14 19.8856 14 18V16Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M14 5C14 4.06812 14 3.60218 14.1522 3.23463C14.3552 2.74458 14.7446 2.35523 15.2346 2.15224C15.6022 2 16.0681 2 17 2H19C19.9319 2 20.3978 2 20.7654 2.15224C21.2554 2.35523 21.6448 2.74458 21.8478 3.23463C22 3.60218 22 4.06812 22 5C22 5.93188 22 6.39782 21.8478 6.76537C21.6448 7.25542 21.2554 7.64477 20.7654 7.84776C20.3978 8 19.9319 8 19 8H17C16.0681 8 15.6022 8 15.2346 7.84776C14.7446 7.64477 14.3552 7.25542 14.1522 6.76537C14 6.39782 14 5.93188 14 5Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
        </svg>
      ),
      path: "/",
      isVisible: Dashboard,
    },
    {
      label: "Repository",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 7C2 5.59987 2 4.8998 2.27248 4.36502C2.51217 3.89462 2.89462 3.51217 3.36502 3.27248C3.8998 3 4.59987 3 6 3C7.40013 3 8.1002 3 8.63498 3.27248C9.10538 3.51217 9.48783 3.89462 9.72752 4.36502C10 4.8998 10 5.59987 10 7V17C10 18.4001 10 19.1002 9.72752 19.635C9.48783 20.1054 9.10538 20.4878 8.63498 20.7275C8.1002 21 7.40013 21 6 21C4.59987 21 3.8998 21 3.36502 20.7275C2.89462 20.4878 2.51217 20.1054 2.27248 19.635C2 19.1002 2 18.4001 2 17V7Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6 17H6.00898" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M2 7H10" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M11.4486 8.26843C11.0937 6.93838 10.9163 6.27336 11.0385 5.69599C11.146 5.18812 11.4108 4.72747 11.7951 4.38005C12.2319 3.98508 12.8942 3.80689 14.2187 3.4505C15.5432 3.09412 16.2055 2.91593 16.7804 3.03865C17.2862 3.1466 17.7449 3.41256 18.0909 3.79841C18.4842 4.23706 18.6617 4.90209 19.0166 6.23213L21.5514 15.7316C21.9063 17.0616 22.0837 17.7266 21.9615 18.304C21.854 18.8119 21.5892 19.2725 21.2049 19.62C20.7681 20.0149 20.1058 20.1931 18.7813 20.5495C17.4568 20.9059 16.7945 21.0841 16.2196 20.9614C15.7138 20.8534 15.2551 20.5874 14.9091 20.2016C14.5158 19.7629 14.3383 19.0979 13.9834 17.7679L11.4486 8.26843Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.7812 16.6953L17.7899 16.693"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 8.00019L18.5001 6"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/project-Repository-Index",
      isVisible: Repository,
    },
    {
      label: "Project Listing",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 7C2 5.59987 2 4.8998 2.27248 4.36502C2.51217 3.89462 2.89462 3.51217 3.36502 3.27248C3.8998 3 4.59987 3 6 3C7.40013 3 8.1002 3 8.63498 3.27248C9.10538 3.51217 9.48783 3.89462 9.72752 4.36502C10 4.8998 10 5.59987 10 7V17C10 18.4001 10 19.1002 9.72752 19.635C9.48783 20.1054 9.10538 20.4878 8.63498 20.7275C8.1002 21 7.40013 21 6 21C4.59987 21 3.8998 21 3.36502 20.7275C2.89462 20.4878 2.51217 20.1054 2.27248 19.635C2 19.1002 2 18.4001 2 17V7Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6 17H6.00898" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M2 7H10" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M11.4486 8.26843C11.0937 6.93838 10.9163 6.27336 11.0385 5.69599C11.146 5.18812 11.4108 4.72747 11.7951 4.38005C12.2319 3.98508 12.8942 3.80689 14.2187 3.4505C15.5432 3.09412 16.2055 2.91593 16.7804 3.03865C17.2862 3.1466 17.7449 3.41256 18.0909 3.79841C18.4842 4.23706 18.6617 4.90209 19.0166 6.23213L21.5514 15.7316C21.9063 17.0616 22.0837 17.7266 21.9615 18.304C21.854 18.8119 21.5892 19.2725 21.2049 19.62C20.7681 20.0149 20.1058 20.1931 18.7813 20.5495C17.4568 20.9059 16.7945 21.0841 16.2196 20.9614C15.7138 20.8534 15.2551 20.5874 14.9091 20.2016C14.5158 19.7629 14.3383 19.0979 13.9834 17.7679L11.4486 8.26843Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.7812 16.6953L17.7899 16.693"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 8.00019L18.5001 6"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/project-Listing-Index",
      isVisible: ProjectListing,
    },
    {
      label: "Initiation",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.08938 15C5.71097 14.1494 5.5 13.2031 5.5 12.2059C5.5 8.50233 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.50233 18.5 12.2059C18.5 13.2031 18.289 14.1494 17.9106 15"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path d="M12 2V3" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22 12H21" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 12H2" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M19.0704 4.92871L18.3633 5.63582"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.6368 5.6368L4.92969 4.92969"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.517 19.3065C15.5274 18.9796 15.9326 18.0548 16.0466 17.1246C16.0806 16.8468 15.852 16.6162 15.572 16.6162L8.47686 16.6164C8.18726 16.6165 7.95468 16.8622 7.98926 17.1498C8.10091 18.0781 8.38271 18.7563 9.45346 19.3065M14.517 19.3065C14.517 19.3065 9.62972 19.3065 9.45346 19.3065M14.517 19.3065C14.3955 21.2515 13.8338 22.0217 12.0068 22.0001C10.0526 22.0362 9.60304 21.0841 9.45346 19.3065"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/project-initiation",
      isVisible: ProjectInitiation,
    },
    {
      label: "IPD",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M14 6V10M10 12H8C6.11438 12 5.17157 12 4.58579 12.5858C4 13.1716 4 14.1144 4 16V18M6 20H10"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4C10 2.34533 10.3453 2 12 2H16C17.6547 2 18 2.34533 18 4C18 5.65467 17.6547 6 16 6H12C10.3453 6 10 5.65467 10 4Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M10 12C10 10.3453 10.3453 10 12 10H16C17.6547 10 18 10.3453 18 12C18 13.6547 17.6547 14 16 14H12C10.3453 14 10 13.6547 10 12Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M10 20C10 18.3453 10.3453 18 12 18H16C17.6547 18 18 18.3453 18 20C18 21.6547 17.6547 22 16 22H12C10.3453 22 10 21.6547 10 20Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M18 12C19.8856 12 20.8284 12 21.4142 11.4142C22 10.8284 22 9.88562 22 8C22 6.11438 22 5.17157 21.4142 4.58579C20.8284 4 19.8856 4 18 4"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/project-ipdIndex",
      isVisible: IPD,
    },
    {
      label: "Initiation Approval",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.9805 7.01757C14.9805 7.01757 15.4805 7.51757 15.9805 8.51757C15.9805 8.51757 17.5687 6.01757 18.9805 5.51757"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.99485 2.02336C7.49638 1.91757 5.56612 2.20539 5.56612 2.20539C4.34727 2.29254 2.01146 2.97586 2.01148 6.96655C2.0115 10.9234 1.98564 15.8012 2.01148 17.7459C2.01148 18.9339 2.7471 21.7054 5.29326 21.8539C8.3881 22.0344 13.9627 22.0728 16.5205 21.8539C17.2051 21.8153 19.4846 21.2778 19.7731 18.7977C20.072 16.2284 20.0125 14.4427 20.0125 14.0177"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.9999 7.01757C21.9999 9.779 19.7591 12.0176 16.995 12.0176C14.231 12.0176 11.9902 9.779 11.9902 7.01757C11.9902 4.25615 14.231 2.01757 16.995 2.01757C19.7591 2.01757 21.9999 4.25615 21.9999 7.01757Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path d="M6.98047 13.0176H10.9805" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6.98047 17.0176H14.9805" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      path: "/project-iaIndex",
      isVisible: InitiationApproval,
    },
    {
      label: "Cogs Estimation",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.232 10.056C20.712 9.516 21.54 8.69999 21.4958 8.36767C21.5298 8.04445 21.3548 7.74083 21.0049 7.13358L20.5114 6.27698C20.1381 5.62915 19.9514 5.30523 19.6338 5.17607C19.3163 5.0469 18.9571 5.14883 18.2388 5.35267L17.0185 5.69637C16.5599 5.80212 16.0788 5.74213 15.66 5.52698L15.3231 5.33261C14.9641 5.10262 14.6879 4.76352 14.535 4.36493L14.201 3.36754C13.9815 2.70753 13.8717 2.37752 13.6103 2.18876C13.3489 2 13.0017 2 12.3074 2H11.1926C10.4982 2 10.151 2 9.88973 2.18876C9.62833 2.37752 9.51853 2.70753 9.29893 3.36754L8.96503 4.36493C8.81213 4.76352 8.53593 5.10262 8.17683 5.33261L7.83993 5.52698C7.42123 5.74213 6.94003 5.80212 6.48143 5.69637L5.26124 5.35267C4.54294 5.14883 4.18374 5.0469 3.86614 5.17607C3.54854 5.30523 3.36194 5.62915 2.98864 6.27698L2.49504 7.13358C2.14515 7.74083 1.97025 8.04445 2.00415 8.36767C2.03815 8.69089 2.27235 8.95137 2.74074 9.47231L3.77184 10.625C4.02374 10.944 4.20274 11.5 4.20274 11.9998C4.20274 12.5 4.02384 13.0558 3.77184 13.3749L2.74074 14.5276C2.27235 15.0485 2.03815 15.309 2.00415 15.6322C1.97025 15.9555 2.14515 16.2591 2.49504 16.8663L2.98864 17.7229C3.36194 18.3707 3.54854 18.6947 3.86614 18.8238C4.18374 18.953 4.54294 18.8511 5.26124 18.6472L6.48143 18.3035C6.94013 18.1977 7.42133 18.2578 7.84013 18.473L8.17693 18.6674C8.53603 18.8974 8.81213 19.2364 8.96493 19.635L9.29893 20.6325C9.51853 21.2925 9.63993 21.6356 9.84 21.78"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17.5 15.7707C19.9853 15.7707 22 15.1508 22 14.3861C22 13.6214 19.9853 13.0015 17.5 13.0015C15.0147 13.0015 13 13.6214 13 14.3861C13 15.1508 15.0147 15.7707 17.5 15.7707Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M22 17.5015C22 18.2662 19.9853 18.8861 17.5 18.8861C15.0147 18.8861 13 18.2662 13 17.5015"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M22 14.3861V20.4784C22 21.3195 19.9853 22.0015 17.5 22.0015C15.0147 22.0015 13 21.3195 13 20.4784V14.3861"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M14.1619 9.44409C13.3219 8.76009 12.6619 8.49609 11.7019 8.49609C9.90181 8.52009 8.25781 10.0071 8.25781 11.9401C8.25781 13.0058 8.58181 13.6801 9.19381 14.3881"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ),
      path: "/cogs-estimation-index",
      isVisible: CogsEstimation,
    },
    {
      label: "Commercials",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M6 12H6.00898M8.9982 12H9.00718M11.9964 12H12.0054M14.9946 12H15.0036M17.9928 12H18.0018M20.991 12H21"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 7C6.67348 5.87847 7.58712 5 8.99282 5C14.9359 5 11.5954 17 17.9819 17C19.3976 17 20.3057 16.1157 21 15"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ),
      path: "/project-commercialsIndex",
      isVisible: Commercials,
    },
    {
      label: "In House Selection",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.2618 3.59937C13.1956 2.53312 12.6625 2 12 2C11.3375 2 10.8044 2.53312 9.73815 3.59937C9.09832 4.2392 8.46427 4.53626 7.55208 4.53626C6.7556 4.53626 5.62243 4.38178 5 5.00944C4.38249 5.63214 4.53628 6.76065 4.53628 7.55206C4.53628 8.46428 4.2392 9.09832 3.59935 9.73817C2.53312 10.8044 2.00001 11.3375 2 12C2.00002 12.6624 2.53314 13.1956 3.59938 14.2618C4.31616 14.9786 4.53628 15.4414 4.53628 16.4479C4.53628 17.2444 4.38181 18.3776 5.00949 19C5.63218 19.6175 6.76068 19.4637 7.55206 19.4637C8.52349 19.4637 8.99128 19.6537 9.68457 20.347C10.2749 20.9374 11.0663 22 12 22C12.9337 22 13.7251 20.9374 14.3154 20.347C15.0087 19.6537 15.4765 19.4637 16.4479 19.4637C17.2393 19.4637 18.3678 19.6175 18.9905 19M18.9905 19C19.6182 18.3776 19.4637 17.2444 19.4637 16.4479C19.4637 15.4414 19.6838 14.9786 20.4006 14.2618C21.4669 13.1956 22 12.6624 22 12C22 11.3375 21.4669 10.8044 20.4006 9.73817M18.9905 19H19"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 9.5L12 13L21.0002 3"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/inHouse-selection-index",
      isVisible: InHouseSelection,
    },
    {
      label: "Formulation Budget Form",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.9473 16.0293C18.3142 22.2695 9.75164 24.0879 4.84361 19.2254C0.0310369 14.4576 1.52098 5.81983 7.84897 3.05264"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17.9822 12.5263C19.9692 12.5263 20.9627 12.5263 21.6043 11.6368C21.6283 11.6036 21.6682 11.5439 21.6897 11.509C22.266 10.5759 21.9689 9.85894 21.375 8.42503C20.8364 7.12476 20.047 5.94331 19.0519 4.94814C18.0566 3.95296 16.8752 3.16354 15.5749 2.62495C14.141 2.03101 13.4241 1.73403 12.4909 2.31029C12.4561 2.33182 12.3964 2.37167 12.3631 2.39565C11.4737 3.03726 11.4737 4.03076 11.4737 6.01774V8.23945C11.4737 10.2603 11.4737 11.2707 12.1015 11.8985C12.7292 12.5263 13.7397 12.5263 15.7605 12.5263H17.9822Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
        </svg>
      ),
      isVisible: FormulationBudgetForm,
      submenu: [
        {
          label: "Formulation Development",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.61414 21.0291C7.23465 21.1299 5.3963 20.8558 5.3963 20.8558C4.2355 20.7728 2.01091 20.122 2.01093 16.3213C2.01095 12.553 1.98632 7.90734 2.01093 6.05525C2.01093 4.92382 2.71152 2.28439 5.13644 2.14296C8.0839 1.97106 13.393 1.93449 15.829 2.14296C16.481 2.17972 18.652 2.69163 18.9268 5.05363C19.2114 7.50058 19.1548 9.20125 19.1548 9.60601"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6582 13.7722C20.6817 12.7957 17.9112 13.9831 15.47 16.4243C13.0289 18.8655 11.8415 21.636 12.818 22.6125C13.7944 23.5889 16.565 22.4016 19.0061 19.9604C21.4473 17.5192 22.6347 14.7487 21.6582 13.7722Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.818 13.7722C11.8415 14.7487 13.0289 17.5192 15.47 19.9604C17.9112 22.4016 20.6817 23.5889 21.6582 22.6125C22.6347 21.636 21.4473 18.8655 19.0061 16.4243C16.565 13.9831 13.7944 12.7957 12.818 13.7722Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M6.76191 6.76376H8.66667" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M6.76191 10.5733H11.5238" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ),
          path: "/pbf/formulation-development-index",
          isVisible: FormulationBudgetForm && FormulationDevelopment,
        },

        {
          label: "API",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.4034 18.9393C11.1104 17.7119 10.2465 14.8581 11.4738 12.565C12.7012 10.272 15.555 9.40806 17.8481 10.6354C20.1411 11.8628 21.0051 14.7166 19.7777 17.0097C18.5503 19.3027 15.6965 20.1666 13.4034 18.9393Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path d="M14.4141 10.9559L16.4627 18.6452" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M10.3681 10.3989C8.81628 12.4861 5.86628 12.92 3.77914 11.3681C1.69199 9.81625 1.25807 6.86625 2.80994 4.77911C4.36181 2.69196 7.31181 2.25804 9.39895 3.80991C11.4861 5.36178 11.92 8.31178 10.3681 10.3989Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path d="M2.62081 8.22281L10.528 7.32974" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ),
          path: "pbf/api-index",
          isVisible: FormulationBudgetForm && API,
        },
        {
          label: "Excipients & PM",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.93432 13.87L12.2568 4.3066C13.6357 2.72209 16.038 2.55541 17.6225 3.93432C19.2071 5.31323 19.3737 7.71556 17.9948 9.30008L16.7474 10.7335C16.1315 10.4846 15.4583 10.3476 14.7531 10.3476C11.8116 10.3476 9.42692 12.7322 9.42692 15.6738M3.93432 13.87C2.55541 15.4545 2.72209 17.8569 4.3066 19.2358C6.27056 20.9449 8.63059 20.0606 10.1359 18.3308C9.68494 17.5487 9.42692 16.6414 9.42692 15.6738M3.93432 13.87L8.51167 8.61012C9.34882 10.0817 10.0942 11.0778 11.0389 11.8563C10.0445 12.824 9.42692 14.1767 9.42692 15.6738"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path
                d="M20.0793 15.6738C20.0793 18.6154 17.6947 21 14.7531 21C11.8115 21 9.42684 18.6154 9.42684 15.6738C9.42684 12.7322 11.8115 10.3475 14.7531 10.3475C17.6947 10.3475 20.0793 12.7322 20.0793 15.6738Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path d="M14 16.7L16.1213 14.5787" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ),
          path: "pbf/excipients-pm-index",
          isVisible: FormulationBudgetForm && ExcipientsPM,
        },
        {
          label: "Analytical ",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path d="M7 4H8" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M7 7H11" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M5 20C6.07093 18.053 7.52279 13.0189 10.3063 13.0189C12.2301 13.0189 12.7283 15.4717 14.6136 15.4717C17.8572 15.4717 17.387 10 21 10"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "pbf/analytical-index",
          isVisible: FormulationBudgetForm && Analytical,
        },
        {
          label: "BE & RLD Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 11.5V8.05426C19 5.20025 19 3.77325 18.1213 2.88663C17.2426 2 15.8284 2 13 2H9C6.17157 2 4.75736 2 3.87868 2.88663C3 3.77325 3 5.20025 3 8.05426V18.6458C3 20.1575 3 20.9133 3.46195 21.2108C4.21687 21.6971 5.38395 20.6774 5.97087 20.3073C6.49493 19.9768 6.74172 19.8301 7.03253 19.8397C7.30166 19.8485 7.54415 20.0014 8.02913 20.3073L9.94 21.5124C10.4555 21.8374 10.7132 22 11 22C11.2868 22 11.5445 21.8374 12.06 21.5124L13 21"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M10 11H7" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M13 7H7" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M16.4575 14.5889C16.3849 14.7642 16.3849 14.9864 16.3849 15.4309V16.3249C16.3849 16.3532 16.3849 16.3673 16.3761 16.3761C16.3673 16.3849 16.3532 16.3849 16.3249 16.3849H15.4309C14.9864 16.3849 14.7642 16.3849 14.5889 16.4575C14.3551 16.5543 14.1694 16.74 14.0726 16.9738C14 17.1491 14 17.3713 14 17.8158C14 18.2603 14 18.4825 14.0726 18.6578C14.1694 18.8916 14.3551 19.0773 14.5889 19.1741C14.7642 19.2467 14.9864 19.2467 15.4309 19.2467H16.3249C16.3532 19.2467 16.3673 19.2467 16.3761 19.2555C16.3849 19.2643 16.3849 19.2784 16.3849 19.3067V20.2007C16.3849 20.6451 16.3849 20.8674 16.4575 21.0427C16.5543 21.2764 16.74 21.4621 16.9738 21.559C17.1491 21.6316 17.3713 21.6316 17.8158 21.6316C18.2603 21.6316 18.4825 21.6316 18.6578 21.559C18.8916 21.4621 19.0773 21.2764 19.1741 21.0427C19.2467 20.8674 19.2467 20.6451 19.2467 20.2007V19.3067C19.2467 19.2784 19.2467 19.2643 19.2555 19.2555C19.2643 19.2467 19.2784 19.2467 19.3067 19.2467H20.2007C20.6451 19.2467 20.8674 19.2467 21.0427 19.1741C21.2764 19.0773 21.4621 18.8916 21.559 18.6578C21.6316 18.4825 21.6316 18.2603 21.6316 17.8158C21.6316 17.3713 21.6316 17.1491 21.559 16.9738C21.4621 16.74 21.2764 16.5543 21.0427 16.4575C20.8674 16.3849 20.6451 16.3849 20.2007 16.3849H19.3067C19.2784 16.3849 19.2643 16.3849 19.2555 16.3761C19.2467 16.3673 19.2467 16.3532 19.2467 16.3249V15.4309C19.2467 14.9864 19.2467 14.7642 19.1741 14.5889C19.0773 14.3551 18.8916 14.1694 18.6578 14.0726C18.4825 14 18.2603 14 17.8158 14C17.3713 14 17.1491 14 16.9738 14.0726C16.74 14.1694 16.5543 14.3551 16.4575 14.5889Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
            </svg>
          ),
          path: "pbf/be-rldCost-Project-details-index",
          isVisible: FormulationBudgetForm && BERLDCost,
        },
        {
          label: "Tooling and Plant Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 22L4.94118 22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M17.7034 22H4.81335V5C4.81335 2.518 5.36977 2 8.03586 2H14.4809C17.147 2 17.7034 2.518 17.7034 5V8"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.1663 13.4692C19.8359 13.4692 22 12.8493 22 12.0846C22 11.3199 19.8359 10.7 17.1663 10.7C14.4967 10.7 12.3325 11.3199 12.3325 12.0846C12.3325 12.8493 14.4967 13.4692 17.1663 13.4692Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 15.2C22 15.9648 19.8359 16.5846 17.1663 16.5846C14.4966 16.5846 12.3325 15.9648 12.3325 15.2"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 12.0846V18.1769C22 19.0181 19.8359 19.7 17.1663 19.7C14.4966 19.7 12.3325 19.0181 12.3325 18.1769V12.0846"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M4.81335 6.00002H8.03586M4.81335 10H8.03586M4.81335 14H8.03586"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          ),
          path: "pbf/tooling-plantcost-index",
          isVisible: FormulationBudgetForm && ToolingPlantCost,
        },
        {
          label: "Manpower Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 13.5C9 14 8.53058 14.3187 6.57757 15.4816C5.1628 16.324 1.45337 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H11"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path
                d="M17.8913 16.3415C20.1605 16.3415 22 15.7755 22 15.0773C22 14.3791 20.1605 13.813 17.8913 13.813C15.6221 13.813 13.7826 14.3791 13.7826 15.0773C13.7826 15.7755 15.6221 16.3415 17.8913 16.3415Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 17.9218C22 18.62 20.1605 19.186 17.8913 19.186C15.6221 19.186 13.7826 18.62 13.7826 17.9218"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 15.0773V20.6398C22 21.4078 20.1605 22.0304 17.8913 22.0304C15.6221 22.0304 13.7826 21.4078 13.7826 20.6398V15.0773"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
            </svg>
          ),
          path: "pbf/manpower-cost-index",
          isVisible: FormulationBudgetForm && ManpowerCost,
        },
        {
          label: "Filing Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 17L18 10L15 17"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 17L6 10L3 17"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4 10H5.0482C6.31166 10 7.5375 9.29466 8.5241 8C10.5562 5.33333 13.4438 5.33333 15.4759 8C16.4625 9.29466 17.6883 10 18.9518 10H20"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 22C19.5603 22 20.9182 20.9483 21.6181 19.3974C21.9707 18.6161 22.147 18.2255 21.8476 17.6127C21.5483 17 21.0525 17 20.061 17H15.939C14.9475 17 14.4517 17 14.1524 17.6127C13.853 18.2255 14.0293 18.6161 14.3819 19.3974C15.0818 20.9483 16.4397 22 18 22Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
              <path
                d="M6 22C7.56035 22 8.9182 20.9483 9.61809 19.3974C9.97068 18.6161 10.147 18.2255 9.84763 17.6127C9.54829 17 9.05251 17 8.06097 17H3.93903C2.94749 17 2.45171 17 2.15237 17.6127C1.85302 18.2255 2.02932 18.6161 2.38191 19.3974C3.0818 20.9483 4.43965 22 6 22Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
              <path
                d="M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
            </svg>
          ),
          path: "pbf/filingcost-index",
          isVisible: FormulationBudgetForm && FilingCost,
        },
      ],
    },
    {
      label: "API Development Form",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.0442 16.433C20.2869 18.5853 19.5494 21.3375 17.3971 22.5801C15.2448 23.8228 12.4926 23.0853 11.25 20.933C10.0074 18.7807 10.7448 16.0285 12.8971 14.7859C15.0494 13.5432 17.8016 14.2807 19.0442 16.433Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path d="M14.3416 19.5378L15.9325 17.9468" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path
            d="M19 12.6839V7.8199C19 6.12616 19 5.27929 18.732 4.60291C18.3013 3.51555 17.3902 2.65784 16.2352 2.25228C15.5168 2 14.6173 2 12.8182 2C9.6698 2 8.09563 2 6.83836 2.44148C4.81714 3.15122 3.22281 4.6522 2.46894 6.55509C2 7.73875 2 9.22077 2 12.1848V14.731C2 17.8013 2 19.3364 2.8477 20.4025C3.09058 20.708 3.37862 20.9792 3.70307 21.2078C4.61506 21.8506 6.35019 21.9757 8.5 22"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12C2 10.159 3.49238 8.66667 5.33333 8.66667C5.99912 8.66667 6.78404 8.78333 7.43137 8.60988C8.00652 8.45576 8.45576 8.00652 8.60988 7.43136C8.78333 6.78404 8.66667 5.99912 8.66667 5.33333C8.66667 3.49238 10.1591 2 12 2"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      isVisible: APIDevelopmentForm,
      submenu: [
        {
          label: "API Development",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.4641 16.5C22.5687 18.4132 21.9132 20.8595 20 21.9641C18.0868 23.0687 15.6405 22.4132 14.5359 20.5C13.4313 18.5868 14.0868 16.1405 16 15.0359C17.9132 13.9313 20.3595 14.5868 21.4641 16.5Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path d="M17.284 19.2598L18.6982 17.8456" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M12.9228 21.8191C12.6615 22.0078 12.3143 22.0078 11.6199 22.0078H10.5051C9.8108 22.0078 9.4636 22.0078 9.2022 21.8191C8.94085 21.6303 8.83106 21.3003 8.61149 20.6403L8.2775 19.6428C8.12464 19.2442 7.84851 18.9052 7.4895 18.6752L7.15267 18.4808C6.73387 18.2656 6.25263 18.2055 5.79394 18.3113L4.57377 18.655C3.85542 18.8589 3.49625 18.9608 3.17867 18.8316C2.86109 18.7025 2.67443 18.3785 2.30114 17.7307L1.80757 16.8741C1.45766 16.2669 1.2827 15.9633 1.31666 15.6401C1.35062 15.3168 1.58483 15.0564 2.05326 14.5354L3.08433 13.3827C3.33636 13.0636 3.51521 12.5078 3.51521 12.0077C3.51521 11.5078 3.3363 10.9518 3.0843 10.6328L2.05326 9.48012C1.58483 8.95918 1.35061 8.69871 1.31666 8.37549C1.2827 8.05227 1.45766 7.74864 1.80757 7.14139L2.30115 6.28479C2.67445 5.63696 2.86109 5.31305 3.17867 5.18388C3.49625 5.05472 3.85541 5.15664 4.57375 5.36048L5.79398 5.70418C6.25259 5.80994 6.73374 5.74994 7.15249 5.53479L7.48937 5.34042C7.84845 5.11043 8.12465 4.77133 8.27753 4.37274L8.61149 3.37536C8.83106 2.71534 8.94085 2.38533 9.2022 2.19657C9.4636 2.00781 9.8108 2.00781 10.5051 2.00781H11.6199C12.3143 2.00781 12.6615 2.00781 12.9228 2.19657C13.1842 2.38533 13.294 2.71534 13.5136 3.37536L13.8475 4.37274C14.0004 4.77133 14.2766 5.11043 14.6357 5.34042L14.9726 5.53479C15.3913 5.74994 15.8725 5.80994 16.3311 5.70418L17.5513 5.36048C18.2696 5.15664 18.6288 5.05472 18.9464 5.18388C19.264 5.31305 19.4506 5.63696 19.8239 6.28479L20.3175 7.14139C20.6674 7.74864 20.8423 8.05227 20.8084 8.37549C20.7744 8.69871 20.5402 8.95918 20.0718 9.48012L19.0407 10.6328C18.7888 10.9518 18.6098 11.5078 18.6098 12.0077"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M14.5195 12C14.5195 13.933 12.9525 15.5 11.0195 15.5C9.0865 15.5 7.51953 13.933 7.51953 12C7.51953 10.067 9.0865 8.5 11.0195 8.5C12.9525 8.5 14.5195 10.067 14.5195 12Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
            </svg>
          ),
          path: "/api/apiksm-development-index",
          isVisible: APIDevelopmentForm && APIDevelopment,
        },
        {
          label: "API Requirement",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5224 19.9436C8.28102 20.0385 5.19914 19.7611 5.19914 19.7611C4.10572 19.6829 2.01028 19.0699 2.0103 15.4899C2.01032 11.9403 1.98712 7.56437 2.0103 5.81979C2.0103 4.75404 2.67022 2.26783 4.95436 2.13462C7.73072 1.97269 12.7317 1.93824 15.0262 2.13462C15.6404 2.16924 17.6853 2.65143 17.9441 4.87631C18.2123 7.18121 18.1477 11.0399 18.1477 11.4212"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.9816 15.3658C21.0963 17.2966 20.4348 19.7656 18.5039 20.8804C16.5731 21.9951 14.1042 21.3336 12.9894 19.4027C11.8746 17.4719 12.5362 15.003 14.467 13.8882C16.3979 12.7734 18.8668 13.435 19.9816 15.3658Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path d="M15.7628 18.1511L17.1901 16.7238" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M6.46796 6.48718H10.0564" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M6.46796 10.0756H13.6447" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ),
          path: "/api/ksm-requirement-index",
          isVisible: APIDevelopmentForm && APIRequirement,
        },
        {
          label: "Other Materials",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.198 3H3.802C3.05147 3 2.6762 3 2.41637 3.17726C2.28768 3.26505 2.18133 3.38109 2.10567 3.51627C1.9529 3.78921 1.99024 4.15793 2.06493 4.89537C2.18958 6.12624 2.2519 6.74168 2.57823 7.18168C2.74084 7.40095 2.94701 7.58519 3.18414 7.72315C3.65999 8 4.28635 8 5.53908 8H18.4609C19.7136 8 20.34 8 20.8159 7.72315C21.053 7.58519 21.2592 7.40095 21.4218 7.18168C21.7481 6.74168 21.8104 6.12624 21.9351 4.89537C22.0098 4.15793 22.0471 3.78921 21.8943 3.51627C21.8187 3.38109 21.7123 3.26505 21.5836 3.17726C21.3238 3 20.9485 3 20.198 3Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3 8V13.0408C3 16.7928 3 18.6688 4.17157 19.8344C5.34315 21 7.22876 21 11 21H13C16.7712 21 18.6569 21 19.8284 19.8344C21 18.6688 21 16.7928 21 13.0408V8"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M10 11H14" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ),
          path: "api/other-materials-index",
          isVisible: APIDevelopmentForm && OtherMaterials,
        },
        {
          label: "Analytical",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path d="M7 4H8" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M7 7H11" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M5 20C6.07093 18.053 7.52279 13.0189 10.3063 13.0189C12.2301 13.0189 12.7283 15.4717 14.6136 15.4717C17.8572 15.4717 17.387 10 21 10"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "api/analytical-index",
          isVisible: APIDevelopmentForm && AnalyticalAPI,
        },
        {
          label: "Manpower Cost ",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 13.5C9 14 8.53058 14.3187 6.57757 15.4816C5.1628 16.324 1.45337 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H11"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              />
              <path
                d="M17.8913 16.3415C20.1605 16.3415 22 15.7755 22 15.0773C22 14.3791 20.1605 13.813 17.8913 13.813C15.6221 13.813 13.7826 14.3791 13.7826 15.0773C13.7826 15.7755 15.6221 16.3415 17.8913 16.3415Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 17.9218C22 18.62 20.1605 19.186 17.8913 19.186C15.6221 19.186 13.7826 18.62 13.7826 17.9218"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 15.0773V20.6398C22 21.4078 20.1605 22.0304 17.8913 22.0304C15.6221 22.0304 13.7826 21.4078 13.7826 20.6398V15.0773"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
            </svg>
          ),
          path: "api/manpower-cost-index",
          isVisible: APIDevelopmentForm && ManpowerAPI,
        },
        {
          label: "Tooling",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.9808 11.6098C17.1612 12.8513 15.2137 13.2084 12.2403 13.8172C10.3272 14.2089 8.45813 12.9732 8.06542 11.0604C7.45698 8.08893 7.01959 6.15676 7.83927 4.91523C8.65887 3.67372 9.12266 3.62222 13.6883 2.68735C14.1291 2.59512 14.4604 3.08323 14.2124 3.45908L12.343 6.29138C11.8685 7.01029 12.065 7.97807 12.7839 8.45253C13.5028 8.927 14.4703 8.72895 14.945 8.01016L16.8151 5.1783C17.0633 4.80251 17.6424 4.91526 17.7309 5.3568C18.6656 9.92167 18.8005 10.3683 17.9808 11.6098Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
              <path
                d="M12.2411 13.8173L7.98846 20.2599C7.22733 21.4129 5.67558 21.7306 4.52252 20.9696C3.36944 20.2084 3.05169 18.6566 3.81282 17.5036L8.0654 11.061"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
              />
              <path
                d="M18.366 17.1596C20.373 17.1596 22 16.659 22 16.0415C22 15.4239 20.373 14.9233 18.366 14.9233C16.359 14.9233 14.732 15.4239 14.732 16.0415C14.732 16.659 16.359 17.1596 18.366 17.1596Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 18.5573C22 19.1748 20.373 19.6754 18.366 19.6754C16.359 19.6754 14.732 19.1748 14.732 18.5573"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 16.0414V20.9613C22 21.6406 20.373 22.1913 18.366 22.1913C16.359 22.1913 14.732 21.6406 14.732 20.9613V16.0414"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
            </svg>
          ),
          path: "api/api-dev-tooling-index",
          isVisible: APIDevelopmentForm && Tooling,
        },
        {
          label: "Plant Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 22L4.94118 22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M17.7034 22H4.81335V5C4.81335 2.518 5.36977 2 8.03586 2H14.4809C17.147 2 17.7034 2.518 17.7034 5V8"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.1663 13.4692C19.8359 13.4692 22 12.8493 22 12.0846C22 11.3199 19.8359 10.7 17.1663 10.7C14.4967 10.7 12.3325 11.3199 12.3325 12.0846C12.3325 12.8493 14.4967 13.4692 17.1663 13.4692Z"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 15.2C22 15.9648 19.8359 16.5846 17.1663 16.5846C14.4966 16.5846 12.3325 15.9648 12.3325 15.2"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M22 12.0846V18.1769C22 19.0181 19.8359 19.7 17.1663 19.7C14.4966 19.7 12.3325 19.0181 12.3325 18.1769V12.0846"
                stroke="#FFFFFF"
                strokeWidth="1.2"
              />
              <path
                d="M4.81335 6.00002H8.03586M4.81335 10H8.03586M4.81335 14H8.03586"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          ),
          path: "api/plant-cost-index",
          isVisible: APIDevelopmentForm && PlantCost,
        },
        {
          label: "API Filing Cost",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 17L18 10L15 17"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 17L6 10L3 17"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4 10H5.0482C6.31166 10 7.5375 9.29466 8.5241 8C10.5562 5.33333 13.4438 5.33333 15.4759 8C16.4625 9.29466 17.6883 10 18.9518 10H20"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 22C19.5603 22 20.9182 20.9483 21.6181 19.3974C21.9707 18.6161 22.147 18.2255 21.8476 17.6127C21.5483 17 21.0525 17 20.061 17H15.939C14.9475 17 14.4517 17 14.1524 17.6127C13.853 18.2255 14.0293 18.6161 14.3819 19.3974C15.0818 20.9483 16.4397 22 18 22Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
              <path
                d="M6 22C7.56035 22 8.9182 20.9483 9.61809 19.3974C9.97068 18.6161 10.147 18.2255 9.84763 17.6127C9.54829 17 9.05251 17 8.06097 17H3.93903C2.94749 17 2.45171 17 2.15237 17.6127C1.85302 18.2255 2.02932 18.6161 2.38191 19.3974C3.0818 20.9483 4.43965 22 6 22Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
              <path
                d="M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z"
                stroke="#FFFFFF"
                strokeWidth="1.3"
              />
            </svg>
          ),
          path: "api/filingcost-index",
          isVisible: APIDevelopmentForm && APIFilingCost,
        },
      ],
    },
    {
      label: "API-Commercials",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M6 12H6.00898M8.9982 12H9.00718M11.9964 12H12.0054M14.9946 12H15.0036M17.9928 12H18.0018M20.991 12H21"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 7C6.67348 5.87847 7.58712 5 8.99282 5C14.9359 5 11.5954 17 17.9819 17C19.3976 17 20.3057 16.1157 21 15"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ),
      path: "/api-commercial-index",
      isVisible: APICommercials,
    },
    {
      label: "In Licensed Project  ",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 12C2 7.28596 2 4.92894 3.46446 3.46446C4.92894 2 7.28596 2 12 2C16.714 2 19.0711 2 20.5356 3.46446C22 4.92894 22 7.28596 22 12C22 16.714 22 19.0711 20.5356 20.5356C19.0711 22 16.714 22 12 22C7.28596 22 4.92894 22 3.46446 20.5356C2 19.0711 2 16.714 2 12Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path d="M2 8.8421H22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinejoin="round" />
          <path
            d="M6.73657 5.6842H6.74555"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9471 5.6842H10.9561"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.78949 13.0526L9.08058 14.1655C9.62336 14.6333 9.89475 14.8673 9.89475 15.1579C9.89475 15.4485 9.62336 15.6825 9.08058 16.1503L7.78949 17.2632"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 17.2632H16.2105"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "/inLicensed-project-index",
      isVisible: InLicensedProject,
    },
    {
      label: "Final Schedule",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 2V4M6 2V4" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M21.5 12.2432C21.5 7.88594 21.5 5.70728 20.2479 4.35364C18.9958 3 16.9805 3 12.95 3H11.05C7.01949 3 5.00424 3 3.75212 4.35364C2.5 5.70728 2.5 7.88594 2.5 12.2432V12.7568C2.5 17.1141 2.5 19.2927 3.75212 20.6464C5.00424 22 7.01949 22 11.05 22H12.95"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M3 8H21" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M18.5 23C20.9853 23 23 20.9853 23 18.5C23 16.0147 20.9853 14 18.5 14C16.0147 14 14 16.0147 14 18.5C14 20.9853 16.0147 23 18.5 23Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path d="M17 17.75L18.1539 19L20 17" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      path: "/final-schedule-index",
      isVisible: FinalSchedule,
    },
    {
      label: "Revenue GC Roll Up  ",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.1087 16.5284C20.3779 16.5284 22.2174 15.9624 22.2174 15.2642C22.2174 14.566 20.3779 14 18.1087 14C15.8395 14 14 14.566 14 15.2642C14 15.9624 15.8395 16.5284 18.1087 16.5284Z"
            stroke="#FFFFFF"
            strokeWidth="1.2"
          />
          <path
            d="M22.2174 18.1087C22.2174 18.8069 20.3779 19.3729 18.1087 19.3729C15.8395 19.3729 14 18.8069 14 18.1087"
            stroke="#FFFFFF"
            strokeWidth="1.2"
          />
          <path
            d="M22.2174 15.2642V20.8268C22.2174 21.5948 20.3779 22.2174 18.1087 22.2174C15.8395 22.2174 14 21.5948 14 20.8268V15.2642"
            stroke="#FFFFFF"
            strokeWidth="1.2"
          />
          <path
            d="M18 11.5V8.05426C18 5.20025 18 3.77325 17.1213 2.88663C16.2426 2 14.8284 2 12 2H8C5.17157 2 3.75736 2 2.87868 2.88663C2 3.77325 2 5.20025 2 8.05426V18.6458C2 20.1575 2 20.9133 2.46195 21.2108C3.21687 21.6971 4.38395 20.6774 4.97087 20.3073C5.49493 19.9768 5.74172 19.8301 6.03253 19.8397C6.30166 19.8485 6.54415 20.0014 7.02913 20.3073L8.94 21.5124C9.4555 21.8374 9.7132 22 10 22C10.2868 22 10.5445 21.8374 11.06 21.5124L12 21"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9 11H6" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 7H6" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      path: "/revenue-index",
      isVisible: RevenueGCRollUp,
    },
    {
      label: "Final PL & Evaluation",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5224 19.9436C8.28102 20.0385 5.19914 19.7611 5.19914 19.7611C4.10572 19.6829 2.01028 19.0699 2.0103 15.4899C2.01032 11.9403 1.98712 7.56437 2.0103 5.81979C2.0103 4.75404 2.67022 2.26783 4.95436 2.13462C7.73072 1.97269 12.7317 1.93824 15.0262 2.13462C15.6404 2.16924 17.6853 2.65143 17.9441 4.87631C18.2123 7.18121 18.1477 11.0399 18.1477 11.4212"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.017 20.0233L21 22M20.0531 17.5265C20.0531 15.5789 18.4742 14 16.5265 14C14.5789 14 13 15.5789 13 17.5265C13 19.4742 14.5789 21.0531 16.5265 21.0531C18.4742 21.0531 20.0531 19.4742 20.0531 17.5265Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.46796 6.48718H10.0564" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6.46796 10.0756H13.6447" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      path: "/final-pl-evaluation-index",
      isVisible: FinalPLEvaluataion,
    },
    {
      label: "Documents",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5224 19.9436C8.28102 20.0385 5.19914 19.7611 5.19914 19.7611C4.10572 19.6829 2.01028 19.0699 2.0103 15.4899C2.01032 11.9403 1.98712 7.56437 2.0103 5.81979C2.0103 4.75404 2.67022 2.26783 4.95436 2.13462C7.73072 1.97269 12.7317 1.93824 15.0262 2.13462C15.6404 2.16924 17.6853 2.65143 17.9441 4.87631C18.2123 7.18121 18.1477 11.0399 18.1477 11.4212"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.017 20.0233L21 22M20.0531 17.5265C20.0531 15.5789 18.4742 14 16.5265 14C14.5789 14 13 15.5789 13 17.5265C13 19.4742 14.5789 21.0531 16.5265 21.0531C18.4742 21.0531 20.0531 19.4742 20.0531 17.5265Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.46796 6.48718H10.0564" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6.46796 10.0756H13.6447" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      path: "/documents-index",
      isVisible: Documents,
    },
    {
      label: "Final Approval",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5224 19.9436C8.28102 20.0385 5.19914 19.7611 5.19914 19.7611C4.10572 19.6829 2.01028 19.0699 2.0103 15.4899C2.01032 11.9403 1.98712 7.56437 2.0103 5.81979C2.0103 4.75404 2.67022 2.26783 4.95436 2.13462C7.73072 1.97269 12.7317 1.93824 15.0262 2.13462C15.6404 2.16924 17.6853 2.65143 17.9441 4.87631C18.2123 7.18121 18.1477 11.0399 18.1477 11.4212"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.017 20.0233L21 22M20.0531 17.5265C20.0531 15.5789 18.4742 14 16.5265 14C14.5789 14 13 15.5789 13 17.5265C13 19.4742 14.5789 21.0531 16.5265 21.0531C18.4742 21.0531 20.0531 19.4742 20.0531 17.5265Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.46796 6.48718H10.0564" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6.46796 10.0756H13.6447" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      path: "/final-approval-index",
      isVisible: FinalApproval,
    },
    {
      label: "Reports",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.21051 17.7895V14.6316M11.4737 17.7895V8.3158M16.7368 17.7895V13.579"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M22 5.15789C22 6.90195 20.5862 8.31579 18.8421 8.31579C17.098 8.31579 15.6842 6.90195 15.6842 5.15789C15.6842 3.41384 17.098 2 18.8421 2C20.5862 2 22 3.41384 22 5.15789Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
          <path
            d="M21.9953 10.9474C21.9953 10.9474 22 11.3047 22 12C22 16.7141 22 19.0711 20.5356 20.5356C19.0711 22 16.714 22 12 22C7.28596 22 4.92894 22 3.46446 20.5356C2 19.0711 2 16.7141 2 12C2 7.28599 2 4.92897 3.46446 3.46449C4.92894 2.00003 7.28596 2.00003 12 2.00003L13.0526 2"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      isVisible: Reports,
      submenu: [
        // {
        //   label: "Reports Dashboard",
        //   icon:
        //     <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        //       <path d="M10.5 13H15.5M7.5 13H7.50898M12.5 17H7.5M15.5 17H15.491" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M17.5 2V4M5.5 2V4" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M2 12.2432C2 7.88594 2 5.70728 3.25212 4.35364C4.50424 3 6.51949 3 10.55 3H12.45C16.4805 3 18.4958 3 19.7479 4.35364C21 5.70728 21 7.88594 21 12.2432V12.7568C21 17.1141 21 19.2927 19.7479 20.6464C18.4958 22 16.4805 22 12.45 22H10.55C6.51949 22 4.50424 22 3.25212 20.6464C2 19.2927 2 17.1141 2 12.7568V12.2432Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M2.5 8H20.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //     </svg>,
        //   path: "/reports/dashboard",
        //   isVisible: Reports
        // },
        {
          label: "Project Timeline",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 13H15.5M7.5 13H7.50898M12.5 17H7.5M15.5 17H15.491"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.5 2V4M5.5 2V4"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12.2432C2 7.88594 2 5.70728 3.25212 4.35364C4.50424 3 6.51949 3 10.55 3H12.45C16.4805 3 18.4958 3 19.7479 4.35364C21 5.70728 21 7.88594 21 12.2432V12.7568C21 17.1141 21 19.2927 19.7479 20.6464C18.4958 22 16.4805 22 12.45 22H10.55C6.51949 22 4.50424 22 3.25212 20.6464C2 19.2927 2 17.1141 2 12.7568V12.2432Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M2.5 8H20.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ),
          path: "/reports/actual-gantt-chart",
          isVisible: Reports,
        },
        // {
        //   label: "Dev Express Gantt Chart",
        //   icon:
        //     <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        //       <path d="M10.5 13H15.5M7.5 13H7.50898M12.5 17H7.5M15.5 17H15.491" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M17.5 2V4M5.5 2V4" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M2 12.2432C2 7.88594 2 5.70728 3.25212 4.35364C4.50424 3 6.51949 3 10.55 3H12.45C16.4805 3 18.4958 3 19.7479 4.35364C21 5.70728 21 7.88594 21 12.2432V12.7568C21 17.1141 21 19.2927 19.7479 20.6464C18.4958 22 16.4805 22 12.45 22H10.55C6.51949 22 4.50424 22 3.25212 20.6464C2 19.2927 2 17.1141 2 12.7568V12.2432Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //       <path d="M2.5 8H20.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        //     </svg>,
        //   path: "/reports/dev-express-gantt-chart",
        //   isVisible: Reports
        // },
        {
          label: "In-Licensed Projects Table",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 13H15.5M7.5 13H7.50898M12.5 17H7.5M15.5 17H15.491"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.5 2V4M5.5 2V4"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12.2432C2 7.88594 2 5.70728 3.25212 4.35364C4.50424 3 6.51949 3 10.55 3H12.45C16.4805 3 18.4958 3 19.7479 4.35364C21 5.70728 21 7.88594 21 12.2432V12.7568C21 17.1141 21 19.2927 19.7479 20.6464C18.4958 22 16.4805 22 12.45 22H10.55C6.51949 22 4.50424 22 3.25212 20.6464C2 19.2927 2 17.1141 2 12.7568V12.2432Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M2.5 8H20.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ),
          path: "/reports/in-licensed-projects-table",
          isVisible: Reports,
        },
      ],
    },
    {
      label: "Admin",
      icon: (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 9H18" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M14 12.5H17" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          <path
            d="M17 3H7C4.23858 3 2 5.23858 2 8V16C2 18.7614 4.23858 21 7 21H17C19.7614 21 22 18.7614 22 16V8C22 5.23858 19.7614 3 17 3Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M5 16C6.20831 13.4189 10.7122 13.2491 12 16"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 9C10.5 10.1046 9.60457 11 8.5 11C7.39543 11 6.5 10.1046 6.5 9C6.5 7.89543 7.39543 7 8.5 7C9.60457 7 10.5 7.89543 10.5 9Z"
            stroke="#FFFFFF"
            strokeWidth="1.5"
          />
        </svg>
      ),
      isVisible: Admin,
      submenu: [
        {
          label: "User Management",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8889 5.22222H22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M10.8889 11.8889H22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M10.8889 18.5556H22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
              <path
                d="M2 6.76984C2 6.76984 3.11111 7.49407 3.66667 8.55556C3.66667 8.55556 5.33333 4.38889 7.55556 3"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 18.9921C2 18.9921 3.11111 19.7163 3.66667 20.7778C3.66667 20.7778 5.33333 16.6111 7.55556 15.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "/user-management-index",
          isVisible: Admin && UserManagement,
        },
        {
          label: "Master Management",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.44444 9.57142V11M6.44444 9.57142C5.15913 9.57142 4.02673 8.94009 3.36258 7.98146M6.44444 9.57142C7.72976 9.57142 8.86216 8.94009 9.52631 7.98146M3.36258 7.98146L2.00047 8.85715M3.36258 7.98146C2.96977 7.41449 2.74074 6.73303 2.74074 6C2.74074 5.26706 2.96971 4.58568 3.36243 4.01876M9.52631 7.98146L10.8884 8.85715M9.52631 7.98146C9.91911 7.41449 10.1481 6.73303 10.1481 6C10.1481 5.26706 9.91922 4.58568 9.52646 4.01876M6.44444 2.42857C7.72986 2.42857 8.86232 3.06 9.52646 4.01876M6.44444 2.42857C5.15903 2.42857 4.02657 3.06 3.36243 4.01876M6.44444 2.42857V1M9.52646 4.01876L10.8889 3.14286M3.36243 4.01876L2 3.14286"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M13.1111 1H13.4141C17.0376 1 18.8494 1 20.1076 1.88649C20.4682 2.14048 20.7882 2.44169 21.0581 2.78099C22 3.96519 22 5.6704 22 9.08081V11.9091C22 15.2016 22 16.8477 21.479 18.1624C20.6413 20.2762 18.8699 21.9434 16.624 22.7318C15.2271 23.2222 13.478 23.2222 9.97975 23.2222C7.98081 23.2222 6.98133 23.2222 6.18306 22.942C4.89974 22.4916 3.88747 21.5388 3.40882 20.331C3.11108 19.5797 3.11108 18.639 3.11108 16.7576V13.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 12.1111C22 14.1566 20.3418 15.8148 18.2964 15.8148C17.5566 15.8148 16.6845 15.6852 15.9651 15.8779C15.3261 16.0491 14.8269 16.5483 14.6557 17.1873C14.463 17.9067 14.5926 18.7788 14.5926 19.5186C14.5926 21.564 12.9344 23.2222 10.8889 23.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "/master-management-index",
          isVisible: Admin && MasterManagement,
        },
        {
          label: "Group Currency",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.44444 9.57142V11M6.44444 9.57142C5.15913 9.57142 4.02673 8.94009 3.36258 7.98146M6.44444 9.57142C7.72976 9.57142 8.86216 8.94009 9.52631 7.98146M3.36258 7.98146L2.00047 8.85715M3.36258 7.98146C2.96977 7.41449 2.74074 6.73303 2.74074 6C2.74074 5.26706 2.96971 4.58568 3.36243 4.01876M9.52631 7.98146L10.8884 8.85715M9.52631 7.98146C9.91911 7.41449 10.1481 6.73303 10.1481 6C10.1481 5.26706 9.91922 4.58568 9.52646 4.01876M6.44444 2.42857C7.72986 2.42857 8.86232 3.06 9.52646 4.01876M6.44444 2.42857C5.15903 2.42857 4.02657 3.06 3.36243 4.01876M6.44444 2.42857V1M9.52646 4.01876L10.8889 3.14286M3.36243 4.01876L2 3.14286"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M13.1111 1H13.4141C17.0376 1 18.8494 1 20.1076 1.88649C20.4682 2.14048 20.7882 2.44169 21.0581 2.78099C22 3.96519 22 5.6704 22 9.08081V11.9091C22 15.2016 22 16.8477 21.479 18.1624C20.6413 20.2762 18.8699 21.9434 16.624 22.7318C15.2271 23.2222 13.478 23.2222 9.97975 23.2222C7.98081 23.2222 6.98133 23.2222 6.18306 22.942C4.89974 22.4916 3.88747 21.5388 3.40882 20.331C3.11108 19.5797 3.11108 18.639 3.11108 16.7576V13.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 12.1111C22 14.1566 20.3418 15.8148 18.2964 15.8148C17.5566 15.8148 16.6845 15.6852 15.9651 15.8779C15.3261 16.0491 14.8269 16.5483 14.6557 17.1873C14.463 17.9067 14.5926 18.7788 14.5926 19.5186C14.5926 21.564 12.9344 23.2222 10.8889 23.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "/group-currency",
          isVisible: Admin && GroupCurrency,
        },
        {
          label: "Date Format",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.44444 9.57142V11M6.44444 9.57142C5.15913 9.57142 4.02673 8.94009 3.36258 7.98146M6.44444 9.57142C7.72976 9.57142 8.86216 8.94009 9.52631 7.98146M3.36258 7.98146L2.00047 8.85715M3.36258 7.98146C2.96977 7.41449 2.74074 6.73303 2.74074 6C2.74074 5.26706 2.96971 4.58568 3.36243 4.01876M9.52631 7.98146L10.8884 8.85715M9.52631 7.98146C9.91911 7.41449 10.1481 6.73303 10.1481 6C10.1481 5.26706 9.91922 4.58568 9.52646 4.01876M6.44444 2.42857C7.72986 2.42857 8.86232 3.06 9.52646 4.01876M6.44444 2.42857C5.15903 2.42857 4.02657 3.06 3.36243 4.01876M6.44444 2.42857V1M9.52646 4.01876L10.8889 3.14286M3.36243 4.01876L2 3.14286"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M13.1111 1H13.4141C17.0376 1 18.8494 1 20.1076 1.88649C20.4682 2.14048 20.7882 2.44169 21.0581 2.78099C22 3.96519 22 5.6704 22 9.08081V11.9091C22 15.2016 22 16.8477 21.479 18.1624C20.6413 20.2762 18.8699 21.9434 16.624 22.7318C15.2271 23.2222 13.478 23.2222 9.97975 23.2222C7.98081 23.2222 6.98133 23.2222 6.18306 22.942C4.89974 22.4916 3.88747 21.5388 3.40882 20.331C3.11108 19.5797 3.11108 18.639 3.11108 16.7576V13.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 12.1111C22 14.1566 20.3418 15.8148 18.2964 15.8148C17.5566 15.8148 16.6845 15.6852 15.9651 15.8779C15.3261 16.0491 14.8269 16.5483 14.6557 17.1873C14.463 17.9067 14.5926 18.7788 14.5926 19.5186C14.5926 21.564 12.9344 23.2222 10.8889 23.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "/date-format-change",
          isVisible: Admin && DateFormat,
        },
        {
          label: "Group Uom",
          icon: (
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.44444 9.57142V11M6.44444 9.57142C5.15913 9.57142 4.02673 8.94009 3.36258 7.98146M6.44444 9.57142C7.72976 9.57142 8.86216 8.94009 9.52631 7.98146M3.36258 7.98146L2.00047 8.85715M3.36258 7.98146C2.96977 7.41449 2.74074 6.73303 2.74074 6C2.74074 5.26706 2.96971 4.58568 3.36243 4.01876M9.52631 7.98146L10.8884 8.85715M9.52631 7.98146C9.91911 7.41449 10.1481 6.73303 10.1481 6C10.1481 5.26706 9.91922 4.58568 9.52646 4.01876M6.44444 2.42857C7.72986 2.42857 8.86232 3.06 9.52646 4.01876M6.44444 2.42857C5.15903 2.42857 4.02657 3.06 3.36243 4.01876M6.44444 2.42857V1M9.52646 4.01876L10.8889 3.14286M3.36243 4.01876L2 3.14286"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M13.1111 1H13.4141C17.0376 1 18.8494 1 20.1076 1.88649C20.4682 2.14048 20.7882 2.44169 21.0581 2.78099C22 3.96519 22 5.6704 22 9.08081V11.9091C22 15.2016 22 16.8477 21.479 18.1624C20.6413 20.2762 18.8699 21.9434 16.624 22.7318C15.2271 23.2222 13.478 23.2222 9.97975 23.2222C7.98081 23.2222 6.98133 23.2222 6.18306 22.942C4.89974 22.4916 3.88747 21.5388 3.40882 20.331C3.11108 19.5797 3.11108 18.639 3.11108 16.7576V13.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 12.1111C22 14.1566 20.3418 15.8148 18.2964 15.8148C17.5566 15.8148 16.6845 15.6852 15.9651 15.8779C15.3261 16.0491 14.8269 16.5483 14.6557 17.1873C14.463 17.9067 14.5926 18.7788 14.5926 19.5186C14.5926 21.564 12.9344 23.2222 10.8889 23.2222"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          path: "/group-uom",
          isVisible: Admin && GroupUom,
        },
      ],
    },
  ];
  return SidebarContentItem;
};

export default SidebarContent;
